<template>
  <div class="verification_pg pg_frm_popup verificaton_popup">
    <div class="pg_bg_layer">

      <div class="row">
        <div class="col-xl-1"></div>
        <div class="col-xl-10 login-user-section login_sec_box content_bx">

          <div class="modal-header">
            <div class="head_txt">Verifying your email</div>
          </div>

          <div class="modal-body">            

            <div class="row mt-4" v-if="!showError && !showLoginInstruction">
              <div class="col-1"></div>
              <div class="col-10" style="text-align: center;">
                <p>Loading.... Please wait</p>
              </div>
            </div>

            <div class="row mt-4" v-if="showError">
              <div class="col-1"></div>
              <div class="col-10"  style="text-align: center;">
                <p>Oops! Something went is not right. <br/>
                  Please check your link again.</p>
              </div>
            </div>

            <div class="row mt-4" v-if="showLoginInstruction">
              <div class="col-1"></div>
              <div class="col-10" style="text-align: center;">
                <p>Your account is already setup. Please login to get started</p>
                <button class="btn btn-secondary btn-lg" @click="goToLoginPage">Login</button>
              </div>
            </div>

            <div v-if="showLoader" class="w-100 h-100 d-flex justify-content-center align-items-center">
              <spinner size="large"></spinner>
            </div>

          </div> <!-- .modal-body -->
        </div>        
      </div>      
    </div>
  </div>
</template>

<script>  
  import { mapActions } from 'vuex'
  import { clear } from '../../../storage'

  export default {
    name: 'verify',
    data: () => {
      return {
        eMail: '',
        verificationCode: '',
        cipCode: '',
        socCode: '',
        programCode: '',
        action: '',
        password: '',
        showError: false,
        showLoader: false,
        showLoginInstruction: false
      }
    },
    mounted () {
      this.loadVerificationPage()
    },
    methods: {
      ...mapActions([
        'loadVerifyUser',
        'setTemporaryUser'
      ]),
      getQueryParamByName(name, url = window.location.href) {
        name = name.replace(/[\[\]]/g, '\\$&')
        let regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)')
        let results = regex.exec(decodeURIComponent(url))
        if (!results || !results[2]) return ''
        return results[2].replace(/\+/g, ' ')
      },
      loadVerificationPage () {
        this.eMail = this.getQueryParamByName('email')
        this.cipCode = this.getQueryParamByName('cipCode')
        this.socCode = this.getQueryParamByName('socCode')
        this.programCode = this.getQueryParamByName('programCode')
        this.verificationCode = this.getQueryParamByName('verificationCode')
        this.action = this.getQueryParamByName('action')
        this.verifyUser()
      },
      goToLoginPage () {
        clear()
        return this.$router.push({name: 'login'})
      },
      async verifyUser () {
        let userObj = {
          'eMail': this.eMail,
          'password': this.verificationCode,
          'verificationCode': this.verificationCode
        }
        if (this.eMail.length < 1) {
          this.showError = true
          this.notifyFailure('Oops! Email is missing. Please try again by going back to the widget')
        } else if (this.verificationCode.length < 5) {
          this.showError = true
          this.notifyFailure('Verificaton Code cannot be fewer than 5 characters!')
        } else {
          this.showLoader = true
          let response = await this.loadVerifyUser(userObj)
          let status = response.status
          let data = response.data
          if (status === 200) {
            if (data.setupComplete) {
              this.showLoginInstruction = true
            } else {
              this.setTemporaryUser()
              this.$parent.isVerify = false
              // navigate To explore based on major
              if ((this.action === 'ExploreRegionalData' || this.action === 'OtherCompanies') && this.cipCode && this.programCode) {
                let url = '/programguide/' + this.cipCode + '/' + this.programCode + '/MAJOR/careerProspects'
                return this.$router.push(url)
              } else if (this.action === 'OtherCareers' && this.cipCode && this.programCode) {
                let url = '/program/' + this.cipCode + '/' + this.programCode + '/MAJOR/careers'
                return this.$router.push(url)
              } else if ((this.action === 'FullCareerReport' || this.action === 'ThirdCareer') && this.socCode) {
                let url = '/career/' + this.socCode + '/detail'
                return this.$router.push(url)
              } else {
                this.showError = true
                this.notifyFailure('Error: Something went wrong!')
              }
            }
          } else {
            this.showError = true
            this.notifyFailure('Error: Verificaton Code did not match!')
          }
          this.showLoader = false
        }
      },
      notifyFailure (text) {
        this.$notify({
          group: 'notify',
          type: 'error',
          title: '',
          text: text
        })
      }
    }
  }
</script>

<style scoped>
  .verification_pg .login_sec_box {
    background: #fff;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    margin: auto;
    height: 520px;
    padding: 0;
    font: 100% openSans_Regular,Sans-serif;
  }

  .verification_pg .login_sec_box {
    height: 95vh;
    max-height: 630px;
  }

  .verificaton_popup .content_bx {
    max-width: 550px;
    height: 350px;
  }

  .verification_pg .login_sec_box .modal-header {
    background: #cfeaf5;
    margin-bottom: 2rem;
  }

  .verification_pg .content_bx .modal-body {
    max-height: calc(100vh - 60px);
  }
</style>



// WEBPACK FOOTER //
// src/app/login/components/Verify.vue